var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tooltip',{staticClass:"nav-action nav-action-setting",attrs:{"content":_vm.title}},[_c('div',{class:[
      'fas',
      _vm.isConnected || _vm.isReconnecting ? 'fa-link' : 'fa-unlink text-danger',
      _vm.isPing ? 'ws-indicator' : '',
      _vm.isReconnecting ? 'ws-reconnecting' : '',
    ]})])
}
var staticRenderFns = []

export { render, staticRenderFns }